import { BROWSER_CREATE_ASSET_DRAFT, BROWSER_EDITIONS_OF_CAMPAIGN } from "constants/actionTypes";
import {
  EMAILS_WITHOUT_CAMPAIGNS_DASHBOARD_LIST,
  EMAILS_WITHOUT_CAMPAIGNS_LIST,
  ASSET_WITHOUT_CAMPAIGN_DETAILS,
  ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT,
  ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_NAME,
  // CAMPAIGNS_FILTER_DATA,
} from "constants/types";
import { getVersionId } from "modules/EmailBrowser/utils";
import {
  createNewDraftEdtionCampaignService,
  getEmailsWithoutCampaignListService,
  updateAssetService,
} from "modules/Services/CampaignsService";
import store from "store";
import { getQueryParam } from "utils";
import { IAssetItem, IEmailItem } from "../interfaces";
import { serializeEmails } from "../utils";

export const getAssetsWithoutCampaignsList = () => {
  store.dispatch({
    type: EMAILS_WITHOUT_CAMPAIGNS_LIST.LOAD,
  });

  getEmailsWithoutCampaignListService()
    .then(({ data }: any) => {
      const assetsWithoutCampaignsList: IAssetItem[] = data;
      store.dispatch({
        type: EMAILS_WITHOUT_CAMPAIGNS_LIST.SUCCESS,
        payload: assetsWithoutCampaignsList,
      });
    })
    .catch((error) => {
      console.log(error);
      store.dispatch({
        type: EMAILS_WITHOUT_CAMPAIGNS_LIST.FAIL,
      });
    });
};

export const removeAssetWithoutCampaign = (assetId: any) => {
  store.dispatch({
    type: EMAILS_WITHOUT_CAMPAIGNS_LIST.REMOVE,
    payload: assetId,
  });
};

export const resetAssetsWithoutCampaigns = () => {
  store.dispatch({
    type: EMAILS_WITHOUT_CAMPAIGNS_LIST.RESET,
  });
};

// util for any setting loading in redux store
export const storeLoading = (type: string, payload?: any) => {
  store.dispatch({
    type,
    ...(payload ? { payload } : {}),
  });
};

export const getAssetWithoutCampaignDetails = () => {
  storeLoading(ASSET_WITHOUT_CAMPAIGN_DETAILS.LOAD);
};

export const updateNameAssetWithoutCampaign = (asset_name: string, email_id: string) => {
  storeLoading(ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_NAME.LOAD);
  updateAssetService(asset_name, email_id)
    .then((res) => {
      if (res.data.success) {
        store.dispatch({
          type: ASSET_WITHOUT_CAMPAIGN_DETAILS_UPDATE_NAME.SUCCESS,
          payload: asset_name,
        });
      } else {
        store.dispatch({
          type: ASSET_WITHOUT_CAMPAIGN_DETAILS.FAIL,
        });
      }
    })
    .catch((err) => {
      console.log("Error updateAssetService: ", err);
      store.dispatch({
        type: ASSET_WITHOUT_CAMPAIGN_DETAILS.FAIL,
      });
    });
};

export const createNewDraftVersionAssetWithoutCampaign = (assetId: any) => {
  storeLoading(ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT.LOAD);
  createNewDraftEdtionCampaignService(assetId)
    .then(({ data }: any) => {
      console.log("CREATE NEW DRAFT EDITION In Asset without campaign");
      console.log(data);
      const date = new Date();
      const newDraftEdition = {
        version_id: data?.id,
        name: data?.name,
        subject: data?.name,
        status: "draft",
        last_update: date.getDate() + " " + date.getMonth(),
        sent_date: data?.creation_time.length > 8 ? null : data.creation_time,
        thumbnail: [],
        total_contacts: 0,
        total_sent: 0,
        total_delivery: 0,
        total_open: 0,
        total_clicks: 0,
        curated_articles_count: 0,
        a_or_b: "a",
        description: "",
        title: "",
        link: "",
      };
      const edition = {
        ...data,
        edition_id: data?.id,
        newlyCreated: false,
        articles_count: 0,
        showUndo: false,
        recentlyAddedArticles: "",
      };
      store.dispatch({
        type: ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT.SUCCESS,
        newDraft: newDraftEdition,
      });
      //* adding the draft to the asset builder
      store.dispatch({
        type: BROWSER_CREATE_ASSET_DRAFT.ADD_SUCCESS,
        payload: { edition, assetId },
      });
    })
    .catch((err: any) => {
      console.log(err);
      store.dispatch({
        type: ASSET_WITHOUT_CAMPAIGN_DETAILS_ADD_NEW_DRAFT.FAIL,
        payload: [],
      });
      // show error alert on frontend
    });
};

export const getEmailsWithoutCampaignsDashboardList = (object?: any) => {
  store.dispatch({
    type: EMAILS_WITHOUT_CAMPAIGNS_DASHBOARD_LIST.LOAD,
  });
  getEmailsWithoutCampaignListService()
    .then(({ data }: any) => {
      // console.log("data : ", data);
      // const assetsWithoutCampaignsList: IEmailItem[] = data;
      const serializedData: IEmailItem[] = serializeEmails(data);
      store.dispatch({
        type: EMAILS_WITHOUT_CAMPAIGNS_DASHBOARD_LIST.SUCCESS,
        payload: serializedData,
      });
    })
    .catch((error) => {
      console.log(error);
      store.dispatch({
        type: EMAILS_WITHOUT_CAMPAIGNS_DASHBOARD_LIST.FAIL,
      });
      // show error alert on frontend
    });
};
